function buildToggleElement(action) {
  let toggleTitle;
  switch (action) {
    case 'in-stock':
      toggleTitle = 'In Stock';
    break;
    case 'on-sale':
      toggleTitle = 'On Sale';
    break;
    case 'same-day-pickup':
      toggleTitle = 'Same Day Pickup';
    default:   
    break;
  }
  const toggleSlideId = 'switch-' + action;
  const toggleElement = document.createElement('div');
  toggleElement.classList.add('collection-search-result-toggle', `collection-${action}-toggle`);
  
  const toggleTitleElement = document.createElement('span');
  toggleTitleElement.classList.add('collection-search-result-toggle__title');
  toggleTitleElement.textContent = toggleTitle;
  
  const toggleSlideElement = document.createElement('div');
  toggleSlideElement.classList.add('collection-search-result-toggle__slide');
  
  const toggleSlideInputElement = document.createElement('input');
  toggleSlideInputElement.classList.add('collection-search-result-toggle__slide__input', `collection-${action}-toggle__slide__input`);
  toggleSlideInputElement.type = 'checkbox';
  toggleSlideInputElement.id = toggleSlideId;

  const toggleSlideLabelElement = document.createElement('label');
  toggleSlideLabelElement.classList.add('collection-search-result-toggle__slide__label', `collection-${action}-toggle__slide__label`);
  toggleSlideLabelElement.for = toggleSlideId;

  /* here we append the built elements to the main toggleElement and return it */
  toggleSlideElement.appendChild(toggleSlideInputElement);
  toggleSlideElement.appendChild(toggleSlideLabelElement);

  toggleElement.appendChild(toggleTitleElement);
  toggleElement.appendChild(toggleSlideElement);

  return toggleElement;
}

function attachToggleListeners(toggleElement, action, filterTitle, filterTag) {
  const toggleInputElement = toggleElement?.querySelector('input');
  const toggleSlideElement = toggleElement?.querySelector('.collection-search-result-toggle__slide');
  
  toggleSlideElement.addEventListener('click', () => {
    const toggleCheckedState = toggleInputElement.checked ? '-off' : '-on';
    
    if (window.innerWidth <= 820 || toggleInputElement.checked === true) { /* if it is a toggle-off we use the same method of clicking the removable buttons as we do on mobile */
      // When filter is hidden
      const toggleEventNameWhenFilterHidden = `togglesWhenFilterHidden:click-${action}-toggle${toggleCheckedState}`;
      document.dispatchEvent(new CustomEvent(toggleEventNameWhenFilterHidden));
    } else {
    // When filter is visible
      if(action === 'same-day-pickup') {
        filterTag = filterTag[0];
      }
      const toggleEventName = `toggles:click-${action}-toggle`;
      document.dispatchEvent(new CustomEvent(toggleEventName));
      setToggleState(toggleInputElement, filterTag);
    }
  });

  document.addEventListener(`filters:show-${action}-toggle`, () => {
    toggleElement.classList.remove('coast-hidden');
  });
  document.addEventListener(`filters:hide-${action}-toggle`, () => {
    toggleElement.classList.add('coast-hidden');
  });
}

//created a new attachToggleListeners for same day pickup because the if statement is special and we pass var when dispatch event
function attachToggleListenersForSameDayPickup(toggleElement, action, filterTitle, filterTags) {
  const toggleInputElement = toggleElement?.querySelector('input');
  const toggleSlideElement = toggleElement?.querySelector('.collection-search-result-toggle__slide');
  
  toggleSlideElement.addEventListener('click', () => {
    const toggleCheckedState = toggleInputElement.checked ? '-off' : '-on';
    
    if (window.innerWidth <= 820) { 
      // When filter is not visiable (on smaller devices, fs filter is not visiable)
      const toggleEventNameWhenFilterHidden = `togglesWhenFilterHidden:click-${action}-toggle${toggleCheckedState}`;
      document.dispatchEvent(new CustomEvent(toggleEventNameWhenFilterHidden, {
      detail: {
       filterTags: filterTags
      }
      }));
    } else {
    // When filter is visible (on larger devices)
      const toggleEventName = `toggles:click-${action}-toggle`;
      document.dispatchEvent(new CustomEvent(toggleEventName, {
      detail: {
       filterTags: filterTags
      }
     }));
    }
  });

  document.addEventListener(`filters:hide-or-show-${action}-toggle`, () => {
    const allSameDayPickupCheckboxes = event.detail.allSameDayPickupCheckboxes; /* allSameDayPickupCheckboxes is all current checkboxs displaying under fs same day pickup filter */
    const fsSameDayPickupFilterTags = getfsSameDayPickupFilterTagsOfCurrentSelectedStore(); /* fsSameDayPickupFilterTags is tags retrieved from store to primary warehouses mapping, the mapping is set in customizer */

    let isAnyTagShowingInFsSameDayPickupFilter = false;
    //check if any of the tags in fsSameDayPickupFilterTags shows up in allSameDayPickupCheckboxes, if does, then show same day pickup toggle
    fsSameDayPickupFilterTags.forEach(fsSameDayPickupFilterTag => {
      if(allSameDayPickupCheckboxes.includes(fsSameDayPickupFilterTag)){
        isAnyTagShowingInFsSameDayPickupFilter = true; 
      }
    });
    
    if(isAnyTagShowingInFsSameDayPickupFilter){
      toggleElement.classList.remove('coast-hidden');
    } else {
      toggleElement.classList.add('coast-hidden');
    }
  });
}

function getRemovableTagsByTagText(topCenterContainerElement, fsFilterTitle, tagText, sameDayPickup = false) {
  let removableTagsFiltered = [];
  const removableWrapper = topCenterContainerElement.querySelector(".removable-tags-wrapper");
  if(removableWrapper) {
    const removableTags = removableWrapper.querySelectorAll(".removable-tag");
    if (fsFilterTitle === fsInStockFilterTitle) {
      const filterTagTextArray = [];
      
        const checkboxText = sameDayPickup ? fsAvailabilityFilterCheckboxTextPartialInStockAt.toLowerCase() : fsAvailabilityFilterCheckboxTextInStockOnlineAtStore.toLowerCase();
        filterTagTextArray.push(checkboxText);
      
      removableTagsFiltered = Array.from(removableTags).filter((removableTag) => {
        const removableTagText = removableTag.querySelector(".removable-tag-text").textContent.toLowerCase();
        const inStockCanadaWideName = "In Stock Canada Wide";
        filterTagTextArray.push(fsInStockCanadaWideTag.toLowerCase(), inStockCanadaWideName.toLowerCase());
  
        return filterTagTextArray.some(tagText => removableTagText.includes(tagText.toLowerCase()));
      });
    } 
  
    if (fsFilterTitle === fsOnSaleFilterTitle) {
      removableTagsFiltered = Array.from(removableTags).filter((removableTag) => {
        const removableTagText = removableTag.querySelector(".removable-tag-text").textContent.toLowerCase();
        const filterTagTextArray = [fsRemovableTagTextOnSale.toLowerCase()];
        return filterTagTextArray.includes(removableTagText);
      });
    }    
  }
  return removableTagsFiltered;
}

function loadTogglesElements(topCenterContainerElement) {
  const buttonsContainer = topCenterContainerElement.querySelector('.buttons-wrapper');
  const isTogglesLoaded = buttonsContainer?.querySelector('.toggle-container');
  const showInStockToggle = window.innerWidth <= 820 ? false : true;
  const showOnSaleToggle = window.innerWidth <= 820 ? false : true;
  const showSameDayPickupToggle = window.innerWidth <= 820 ? false : true;
  if(buttonsContainer && !isTogglesLoaded) {
    
      const storeId = GetSelectedStoreId();
      const inStockFilterTag = `${fsInStockOnlineFilterTagPartial}${storeId}`;
    
    const toggleContainer = document.createElement('div');
    toggleContainer.classList.add('toggle-container');

    buttonsContainer.insertAdjacentElement('afterbegin', toggleContainer);

    let isInStockCanadaWideActive = false;
    let isInStockLocationActive = false;

    //same day pickup toggle
    let sameDayPickupToggleInputElement = null;

    const fsSameDayPickupFilterTags = getfsSameDayPickupFilterTagsOfCurrentSelectedStore();

    if(showSameDayPickupToggle) {
      const sameDayPickupAction = 'same-day-pickup';
      const sameDayPickupToggle = buildToggleElement(sameDayPickupAction);
      sameDayPickupToggleInputElement = sameDayPickupToggle.querySelector('input');
      toggleContainer.appendChild(sameDayPickupToggle);
      attachToggleListeners(sameDayPickupToggle, sameDayPickupAction, fsSameDayPickupFilterTitle, fsSameDayPickupFilterTags);
      
        setToggleState(sameDayPickupToggleInputElement, fsSameDayPickupFilterTags[0]);   
      
    } 

    let inStockToggleInputElement = null;
   
    if(showInStockToggle) {
      const inStockAction = 'in-stock';
      const inStockToggle = buildToggleElement(inStockAction);
      inStockToggleInputElement = inStockToggle.querySelector('input');
      toggleContainer.appendChild(inStockToggle);
      attachToggleListeners(inStockToggle, inStockAction, fsInStockFilterTitle, inStockFilterTag);
      setToggleState(inStockToggleInputElement, inStockFilterTag);
    }

    let onSaleToggleInputElement = null;

    if(showOnSaleToggle) {
      const onSaleAction = 'on-sale';
      const onSaleToggle = buildToggleElement(onSaleAction);
      onSaleToggleInputElement = onSaleToggle.querySelector('input');
      toggleContainer.appendChild(onSaleToggle);
      attachToggleListeners(onSaleToggle, onSaleAction, fsOnSaleFilterTitle, fsOnSaleFilterTag);
      setToggleState(onSaleToggleInputElement, fsOnSaleFilterTag);
    }

    
    if((showInStockToggle || showOnSaleToggle || showSameDayPickupToggle)) {

      document.addEventListener(`togglesWhenFilterHidden:click-same-day-pickup-toggle-off`, () => {
        
          const removableTags = getRemovableTagsByTagText(topCenterContainerElement, fsInStockFilterTitle, inStockFilterTag, true);
        
        if(removableTags.length > 0) {
          removableTags.forEach((removableTag) => {    
            const removableTagCloseBtn = removableTag.querySelector(".removable-tag-remove-button");
            removableTagCloseBtn.click();
            setTimeout(() => { /* we add a delay to give the url time to update before we setToggleState */
              setToggleState(inStockToggleInputElement, inStockFilterTag);
            }, 200);
          });
        }
      });
      
      document.addEventListener(`togglesWhenFilterHidden:click-in-stock-toggle-on`, () => {
        updateUrlFilters(fsInStockFilterTitle, inStockFilterTag);
      });

      document.addEventListener(`togglesWhenFilterHidden:click-in-stock-toggle-off`, () => {
        
          const removableTags = getRemovableTagsByTagText(topCenterContainerElement, fsInStockFilterTitle, inStockFilterTag);
        
        if(removableTags.length > 0) {
          removableTags.forEach((removableTag) => {    
            const removableTagCloseBtn = removableTag.querySelector(".removable-tag-remove-button");
            removableTagCloseBtn.click();
            setTimeout(() => { /* we add a delay to give the url time to update before we setToggleState */
              setToggleState(inStockToggleInputElement, inStockFilterTag);
            }, 200);
          });
        }
      });
      
      document.addEventListener(`togglesWhenFilterHidden:click-on-sale-toggle-on`, () => {
        updateUrlFilters(fsOnSaleFilterTitle, fsOnSaleFilterTag);
      });

      document.addEventListener(`togglesWhenFilterHidden:click-on-sale-toggle-off`, () => {
        const removableTags =  getRemovableTagsByTagText(topCenterContainerElement, fsOnSaleFilterTitle);
        if(removableTags.length > 0) {
          const removableTagCloseBtn = removableTags[0].querySelector(".removable-tag-remove-button");
          removableTagCloseBtn.click();
          setTimeout(() => { /* we add a delay to give the url time to update before we setToggleState */
            setToggleState(onSaleToggleInputElement, fsOnSaleFilterTag);
          }, 200);
        }
      });

      document.addEventListener(`updateToggleStateWhenRemoveableTagsClicked`, () => {
        setToggleState(inStockToggleInputElement, inStockFilterTag);
        setToggleState(onSaleToggleInputElement, fsOnSaleFilterTag);
        
          setToggleState(sameDayPickupToggleInputElement, fsSameDayPickupFilterTags[0]);
        
      });
      
      window.addEventListener('fs-custom-events-filter-clicked', (e) => {
        setToggleState(inStockToggleInputElement, inStockFilterTag);
        setToggleState(onSaleToggleInputElement, fsOnSaleFilterTag);
        
          setToggleState(sameDayPickupToggleInputElement, fsSameDayPickupFilterTags[0]);
        
      });
    }
  }
}
